import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function deleteCenterOlPayments(ids: number[]) {
  return restApiClient.url(encodeNestedObject(API.centerOlPayments.delete.url, { ids })).delete()
}
